import React, { type ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { CheckIcon } from "ui/icons";

export function CheckHeading({ children }: { children: ReactNode }) {
  return (
    <Flex align="center" gap={3}>
      <Flex
        align="center"
        boxSize={{ base: 4, md: 6 }}
        bg="base.darkBackground"
        borderRadius="full"
        color="white"
        flexShrink={0}
        justify="center"
      >
        <CheckIcon boxSize={{ base: 3, md: 4 }} />
      </Flex>
      <Text as="h3" textStyle="h7" fontSize={{ base: "lg", sm: "xl", xl: "2xl" }}>
        {children}
      </Text>
    </Flex>
  );
}
